module.exports = __webpack_public_path__ + "img/hvid_glogg_ekstrakt.3b919181.jpg";